export default "__VITE_ASSET__BHG$jTOM__"